"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _InteractionData_dragAnchors, _InteractionData_dragOrigin, _InteractionData_groupId, _InteractionData_interactionStates, _InteractionData_interactionTypes, _InteractionData_restrictedManagers;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionData = void 0;
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
// #endregion Interfaces (1)
// #region Classes (1)
class InteractionData extends viewer_shared_node_tree_1.AbstractTreeNodeData {
    // #endregion Properties (6)
    // #region Constructors (1)
    /**
     * Creates an interaction data item.
     *
     * @param interactionTypes the data as key-value pairs
     * @param groupId the group id to be able to interact with multiple nodes at once
     * @param id the id that is used internally (leave empty if in doubt)
     * @param version the version that is used internally (leave empty if in doubt)
     */
    constructor(interactionTypes, groupId, restrictedManagers, id, version) {
        super(id, version);
        // #region Properties (6)
        _InteractionData_dragAnchors.set(this, []);
        _InteractionData_dragOrigin.set(this, void 0);
        _InteractionData_groupId.set(this, void 0);
        _InteractionData_interactionStates.set(this, {});
        _InteractionData_interactionTypes.set(this, {});
        _InteractionData_restrictedManagers.set(this, []);
        __classPrivateFieldSet(this, _InteractionData_interactionTypes, interactionTypes, "f");
        __classPrivateFieldSet(this, _InteractionData_groupId, groupId, "f");
        if (restrictedManagers !== undefined)
            __classPrivateFieldSet(this, _InteractionData_restrictedManagers, restrictedManagers, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (12)
    get dragAnchors() {
        return __classPrivateFieldGet(this, _InteractionData_dragAnchors, "f");
    }
    set dragAnchors(value) {
        __classPrivateFieldSet(this, _InteractionData_dragAnchors, value, "f");
    }
    get dragOrigin() {
        return __classPrivateFieldGet(this, _InteractionData_dragOrigin, "f");
    }
    set dragOrigin(value) {
        __classPrivateFieldSet(this, _InteractionData_dragOrigin, value, "f");
    }
    get groupId() {
        return __classPrivateFieldGet(this, _InteractionData_groupId, "f");
    }
    set groupId(value) {
        __classPrivateFieldSet(this, _InteractionData_groupId, value, "f");
    }
    get interactionStates() {
        return __classPrivateFieldGet(this, _InteractionData_interactionStates, "f");
    }
    set interactionStates(value) {
        __classPrivateFieldSet(this, _InteractionData_interactionStates, value, "f");
    }
    get interactionTypes() {
        return __classPrivateFieldGet(this, _InteractionData_interactionTypes, "f");
    }
    set interactionTypes(value) {
        __classPrivateFieldSet(this, _InteractionData_interactionTypes, value, "f");
    }
    get restrictedManagers() {
        return __classPrivateFieldGet(this, _InteractionData_restrictedManagers, "f");
    }
    set restrictedManagers(value) {
        __classPrivateFieldSet(this, _InteractionData_restrictedManagers, value, "f");
    }
    // #endregion Public Getters And Setters (12)
    // #region Public Methods (1)
    /**
     * Clones the scene graph data.
     */
    clone() {
        return new InteractionData(__classPrivateFieldGet(this, _InteractionData_interactionTypes, "f"), __classPrivateFieldGet(this, _InteractionData_groupId, "f"), __classPrivateFieldGet(this, _InteractionData_restrictedManagers, "f"), this.id, this.version);
    }
}
exports.InteractionData = InteractionData;
_InteractionData_dragAnchors = new WeakMap(), _InteractionData_dragOrigin = new WeakMap(), _InteractionData_groupId = new WeakMap(), _InteractionData_interactionStates = new WeakMap(), _InteractionData_interactionTypes = new WeakMap(), _InteractionData_restrictedManagers = new WeakMap();
// #endregion Classes (1)
//# sourceMappingURL=InteractionData.js.map